import table_messages from 'messages/table_messages';

const notEdited = {
  filters: [{ id: 150, name: [table_messages.not_edited, { days: 150 }] }],
  isSingleSelect: true,
};

export default notEdited;
